import Vue from 'vue';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  CREATE_WALLET,
  LOAD_WALLETS_LIST,
  LOAD_AML_REPORTS,
  RESET_WALLETS,
  LOAD_BALANCES,
  EDIT_WALLET_DESCRIPTION, DELETE_WALLET, REFRESH_WALLET, CHECK_WALLET_AML,
} from '@/store/const/wallets';

export default {
  namespaced: true,
  state: {
    wallets: {
      list: [],
      pagination: {},
    },
    statuses: {
      checking: 'На проверке',
      wait: 'Ожидание',
      in_progress: 'Выполняется',
      error: 'Ошибка',
      success: 'Выполнен',
    },
    balances: {
      ETH: { original: 0, token: 0, fee: 0 },
      TRX: { original: 0, token: 0, fee: 0 },
    },
    fees: { ETH: 0, TRX: 0 },
    energy: { amount: 0, wallet: '' },
    amlReports: { address: '', requestKey: '', list: [], pagination: {} },
  },
  getters: {
    wallets: (state) => state.wallets,
    statuses: (state) => state.statuses,
    balances: (state) => state.balances,
    energy: (state) => state.energy,
    fees: (state) => state.fees,
    amlReports: (state) => state.amlReports,
  },
  actions: {
    [LOAD_WALLETS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(
        HTTP_GET,
        {
          method: LOAD_WALLETS_LIST,
          namespace: 'wallets',
          params,
        },
        { root: true },
      );
    },
    [LOAD_AML_REPORTS]: async ({ dispatch, commit }, { params }) => {
      const requestKey = `${params.address}:${params.page}:${params.per_page}`;
      commit(LOAD_AML_REPORTS, { address: params.address, requestKey, reset: true });
      const result = await dispatch(
        HTTP_GET,
        {
          method: LOAD_AML_REPORTS,
          namespace: 'wallets',
          params,
          no_commit: true,
        },
        { root: true },
      );
      if (result && result.success) {
        commit(LOAD_AML_REPORTS, { address: params.address, requestKey, data: result.data });
      }
      return result;
    },
    [CREATE_WALLET]: async ({ dispatch }, { blockchain, description, accumulating, type, amount }) => {
      return await dispatch(
        HTTP_POST,
        {
          method: CREATE_WALLET,
          namespace: 'wallets',
          body: {
            blockchain,
            description,
            ...(accumulating ? { accumulating: true, type, ...(amount ? { amount } : {}) } : {}),
          },
          no_commit: true,
        },
        { root: true },
      );
    },
    [DELETE_WALLET]: async ({ dispatch }, id) => {
      return await dispatch(
        HTTP_DELETE,
        {
          method: DELETE_WALLET,
          namespace: 'wallets',
          replace: { id },
          no_commit: true,
        },
        { root: true },
      );
    },
    [REFRESH_WALLET]: async ({ dispatch }, id) => {
      return await dispatch(
        HTTP_POST,
        {
          method: REFRESH_WALLET,
          namespace: 'wallets',
          replace: { id },
          no_commit: true,
        },
        { root: true },
      );
    },
    [CHECK_WALLET_AML]: async ({ dispatch }, id) => {
      return await dispatch(
        HTTP_POST,
        {
          method: CHECK_WALLET_AML,
          namespace: 'wallets',
          replace: { id },
          no_commit: true,
        },
        { root: true },
      );
    },
    [LOAD_BALANCES]: async ({ dispatch }) => {
      return await dispatch(
        HTTP_GET,
        {
          method: LOAD_BALANCES,
          namespace: 'wallets',
        },
        { root: true },
      );
    },
    [EDIT_WALLET_DESCRIPTION]: async ({ dispatch }, { wallet_id, text }) => {
      return await dispatch(
        HTTP_PUT,
        {
          method: EDIT_WALLET_DESCRIPTION,
          namespace: 'wallets',
          body: { text },
          replace: { wallet_id },
          no_commit: true,
        },
        { root: true },
      );
    },
  },
  mutations: {
    [LOAD_WALLETS_LIST]: (state, { data }) => {
      Vue.set(state.wallets, 'list', data.list);
      Vue.set(state.wallets, 'pagination', data.pagination);
    },
    [LOAD_AML_REPORTS]: (state, { address, requestKey, data, reset = false }) => {
      if (reset) {
        Vue.set(state, 'amlReports', { address, requestKey, list: [], pagination: {} });
      } else if (state.amlReports.requestKey === requestKey) {
        Vue.set(state, 'amlReports', { address, requestKey, ...data });
      }
    },
    [LOAD_BALANCES]: (state, { data }) => {
      Vue.set(state, 'balances', data.balances);
      Vue.set(state, 'fees', data.fees);
      Vue.set(state, 'energy', data.energy);
    },
    [RESET_WALLETS]: (state) => {
      Vue.set(state, 'wallets', { pagination: {}, list: [] });
    },
  },
};
